import { NgIf } from '@angular/common';
import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PreventDefaultDirective } from 'src/app/directive/prevent-default.directive';
import { EnvironmentService } from 'src/app/service/environment.service';
import { ThemeService } from 'src/app/service/theme.service';
import {
  environmentAU,
  environmentGLOBAL,
  environmentUS,
} from 'src/environments/environment';

@Component({
  selector: 'app-modal',
  imports: [NgIf],
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
})
export class ModalComponent {
  @Input() theme: any;
  environment: any;
  _open: boolean = false;
  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private themeService: ThemeService,
    private environmentService: EnvironmentService
  ) {
    this.environment = this.environmentService.environment;
    this.themeService.themeEvents.subscribe((data) => {
      if (data.type == 'clear') {
        this._open = false;
        this.renderer.removeClass(this.el.nativeElement, 'active');
      }
      if (data.type == 'countryOpen') {
        this._open = true;
        this.renderer.addClass(this.el.nativeElement, 'active');
      }
    });
  }

  clear() {
    this.themeService.clear();
  }

  selectCountry(target: any) {
    let result = [environmentAU, environmentUS, environmentGLOBAL].find(
      (x) => x.store == target?.value
    );
    window.location.href = result!.siteUrl;
  }

  selectCurrency(target: any) {}

  submit() {}
}
